export default __webpack_public_path__ + "static/media/footer-background.24475349.png";